const footColumns = [
  {
    title: "频道栏目",
    links: [
      { label: "今日猛料局", href: "#columns" },
      { label: "王牌节目拆解", href: "#columns" },
      { label: "网红内幕档案", href: "#columns" },
      { label: "全网猛料速递", href: "#columns" },
    ],
  },
  {
    title: "专题与内容",
    links: [
      { label: "精选内容盘点", href: "#content" },
      { label: "热门专题节目", href: "#topics" },
      { label: "今日热榜 TOP", href: "#hot" },
      { label: "最新更新", href: "#content" },
    ],
  },
  {
    title: "关于频道",
    links: [
      { label: "频道介绍", href: "#reviews" },
      { label: "编辑部的话", href: "#reviews" },
      { label: "常见问题", href: "#faq" },
      { label: "投稿互动", href: "#contact" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-200 border-t border-background-300">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-8">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 rounded-xl bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-water-flash-fill text-2xl"></i>
              </span>
              <span className="font-heading font-bold text-2xl text-foreground-950">吃瓜频道</span>
            </div>
            <p className="text-foreground-600 text-sm leading-relaxed mt-4 max-w-md">
              热门栏目专题盘点、王牌栏目独家策划与每日精选更新的娱乐八卦资讯门户。
              以「讲事实、看门道、不跟风」为原则，做你追瓜路上最靠谱的进度条。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {["ri-weibo-fill", "ri-bilibili-fill", "ri-wechat-2-fill", "ri-douban-fill"].map((ic) => (
                <a
                  key={ic}
                  href="#top"
                  aria-label="社交媒体入口"
                  className="w-9 h-9 rounded-lg bg-background-50 text-foreground-500 hover:text-primary-600 hover:bg-background-50 flex items-center justify-center border border-background-300 transition-colors"
                >
                  <i className={`${ic} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {footColumns.map((col) => (
            <nav key={col.title} className="lg:col-span-2" aria-label={col.title}>
              <h4 className="font-medium text-foreground-950 text-sm mb-4">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="text-foreground-600 text-sm hover:text-primary-600 transition-colors whitespace-nowrap"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}

          <div className="lg:col-span-1"></div>
        </div>
      </div>

      <div className="border-t border-background-300 px-4 md:px-8 py-5">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 吃瓜频道 · 追瓜路上的进度条 · 保留所有权利
          </p>
          <p className="text-xs text-foreground-500">
            我们主张理性吃瓜，尊重事实与当事人，本频道内容仅供娱乐参考。
          </p>
        </div>
      </div>
    </footer>
  );
}